import { Component, OnInit, Inject } from '@angular/core';
import { TipoEntregaService } from '../../../../../providers/tipo-entrega.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-eliminar-tipo-entrega-dialog',
  templateUrl: './eliminar-tipo-entrega-dialog.component.html',
  styleUrls: ['./eliminar-tipo-entrega-dialog.component.scss']
})
export class EliminarTipoEntregaDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  descripcion: string = null;

  constructor(
    public dialogCrear: MatDialogRef<EliminarTipoEntregaDialog>,
    private tipoEntregaService: TipoEntregaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.cargando = true;
    this.tipoEntregaService.getTiposEntrega(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        IdTipoEntrega: this.data.IdTipoEntrega,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var tipoEntrega = respuesta.data.entregas[0];
          if (tipoEntrega) {
            this.descripcion = tipoEntrega.descripcion;
          } else {
            this.error = "Es posible que ya no exista en la base de datos";
          }
        }

        this.cargando = false;
      },
      error => {
        this.cargando = false;
      }
    );
  }

  onCancelar(): void {
    this.dialogCrear.close();
  }

  onEliminar(): void {
    this.error = '';

    try { // cacheo de errores antes de llamar al servidor
      this.cargando = true;
      this.tipoEntregaService.eliminarTipoEntrega(this.data.IdTipoEntrega).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.dialogCrear.close(respuesta);
          } else {
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        });
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }
}